import { routePaths } from "@/App";
import { Skeleton } from "@/components/ui/skeleton";
import { ChevronLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

export function TourDetailsSkeleton() {
  const { t } = useTranslation();

  return (
    <div className="h-dvh flex flex-col">
      <div className="bg-white px-4 py-6 border-b-2 border-neutral pt-safe">
        <Link
          to={routePaths.home}
          className="mb-8 flex items-center font-medium gap-1.5 bg-slate-100 w-fit p-2 pr-4 rounded"
        >
          <ChevronLeft className="w-5 h-5" strokeWidth={2.5} />
          {t("common.back")}
        </Link>

        <div className="space-y-2">
          <header className="flex justify-between">
            <Skeleton className="w-40 h-8" />
          </header>

          <Skeleton className="w-16 h-5" />
        </div>
      </div>

      <div className="flex-1 overflow-y-auto bg-list-background p-4 space-y-4">
        <Skeleton className="w-full h-12" />
        <Skeleton className="w-full h-24" />
        <Skeleton className="w-full h-24" />
        <Skeleton className="w-full h-12" />
      </div>

      <div className="p-4 bg-white border-t-2 border-neutral pb-safe">
        <Skeleton className="w-full h-12" />
      </div>
    </div>
  );
}
